import { CssFeatureSymbol } from '../../ioc/catharsis-ioc'
import { zIndexCssDomApplier } from './zIndexCssDomApplier'
import type { ZIndexCssFeature } from './zIndexCss.types'
import { defaultZIndexCss } from './zIndexCssCompNode'
import { compLayouts, editorCompLayouts } from '../responsiveLayout/compLayoutsCompNode'
import { pinnedStyle } from '../pinnedLayout/pinnedLayoutCompNode'
import type { BindFeature } from '@wix/thunderbolt-catharsis-ioc'
import { compInfoNodes } from '@wix/thunderbolt-component-isolation'

export const zIndexCssFeature: ZIndexCssFeature = {
	featureName: 'zIndexCss',
	experimentName: 'OPEN_TO_ALL',
	renderableNodes: { defaultZIndexCss: defaultZIndexCss(false) },
	intermediateNodes: {
		compLayouts,
		pinnedStyle,
		hasResponsiveLayout: compInfoNodes.hasResponsiveLayout,
	},
	dataMaps: ['document_data', 'layout_data', 'component_properties'],
	domApplier: zIndexCssDomApplier,
}

export const editorZIndexCssFeature: ZIndexCssFeature = {
	...zIndexCssFeature,
	renderableNodes: { defaultZIndexCss: defaultZIndexCss(true) },
	intermediateNodes: {
		compLayouts: editorCompLayouts,
		pinnedStyle,
		hasResponsiveLayout: compInfoNodes.hasResponsiveLayout,
	},
}

export const page: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(zIndexCssFeature)
}

export const editor: BindFeature = (bind) => {
	bind(CssFeatureSymbol).toConstantValue(editorZIndexCssFeature)
}
